import { Link } from 'react-router-dom';
import { Calendar, MapPin, Clock, Mail, Phone, Anchor, Ship } from 'lucide-react';

const EventInfo = () => {
  return (
    <section id="about" className="relative py-12 sm:py-16 md:py-20 overflow-hidden">
      {/* Background with pattern and gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-navy to-primary-green"></div>
      <div className="absolute inset-0 bg-blue-pattern opacity-5 mix-blend-overlay"></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">Event Information</h2>
            <div className="h-0.5 w-16 sm:w-24 bg-[#A65C4A] mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 items-center">
            {/* Info Details with Glass Morphism */}
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 md:p-8 border border-white/20 shadow-lg">
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <Calendar className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Date</h3>
                    <p className="text-white/80">Coming soon</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <MapPin className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Venue</h3>
                    <p className="text-white/80">
                      Ethiopian Skylight Hotel<br />
                      Addis Ababa, Ethiopia
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <Clock className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Time</h3>
                    <p className="text-white/80">08:00 AM - 05:00 PM (EAT)</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <Anchor className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Presented By</h3>
                    <p className="text-white/80">
                      Ministry of Transport & Logistics, Ethiopia<br />
                      Ethiopian Maritime Training Institute 
                    </p>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <Mail className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Contact Email</h3>
                    <p className="text-white/80">info@africamaritimeconference.com</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-white/10 rounded-full">
                    <Phone className="h-5 w-5 text-[#A65C4A]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Contact Phone</h3>
                    <p className="text-white/80">+251 970 317 022</p>
                  </div>
                </div>
              </div>
              
              {/* Registration Closed */}
              <div className="mt-8">
                <button 
                  disabled
                  className="inline-block bg-gray-400 text-white font-medium py-3 px-6 rounded shadow-md cursor-not-allowed flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  <span>Registration Closed</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            {/* Map/Image Section */}
            <div className="mt-6 md:mt-0">
              <div className="rounded-lg overflow-hidden shadow-lg border border-white/20">
                <img 
                  className="w-full h-[350px] object-cover" 
                  src="https://www.ethiopianskylighthotel.com/ResourcePackages/Skylight/assets/Images/home-page.png" 
                  alt="Ethiopian Skylight Hotel" 
                  loading="lazy"
                />
                <div className="bg-white/10 backdrop-blur-md p-4 border-t border-white/10">
                  <h3 className="text-lg font-semibold text-white">Ethiopian Skylight Hotel</h3>
                  <p className="text-white/80 text-sm mt-1">Conference venue in Addis Ababa, Ethiopia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventInfo;